import React, { useRef, useState, useEffect } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
// import { NavLink } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { useParams } from "react-router-dom";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import {
  adminGetListManagementGroup,
  GetCitiesListManagement,
  GetCountriesListManagement,
  GetStatesListManagement,
} from "@services/list-management.service";
import { toast } from "react-toastify";
import "./vendors-add-details.scss";
import {
  clientAdminFileUpload,
  clientAdminPublicFileUpload,
  clientFileUpload,
  GetSpecificOrganization,
  UpdateSpecificOrganization,
} from "@services/client-list.service";
import countries from "@_common/contry.json";
import { ChromePicker } from "react-color";
import Loader from "@components/common/Loader";
import _ from "lodash";
import { useCallbackPrompt } from "../../../prompt/useCallbackPrompt";
import PromptModal from "../../../prompt/modal";
import NoAccessPage from "@components/common/NoAccess";
import { sanitizeInput } from "@_common/dompurify";

interface IOrgProfileProps {}

const OrgProfile: React.FunctionComponent<IOrgProfileProps> = (props: any) => {
  let params = useParams();
  //   let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [request, setRequest] = useState<any>({
    organisation_name: "",
    organisation_logo: "",
    industry: "",
    business_type: "",
    address1: "",
    address2: "",
    country_id: "",
    state_id: "",
    city_id: "",
    pincode: "",
    self_compliance_completion_backdate_limit_days: "",
    sc_future_date_completion_days_limit: "",
    auto_populate_self_compliance_completion_date: true,
    is_required_reason_for_non_compliance: true,
    phone1: "",
    phone2: "",
    email1: "",
    email2: "",
    primary_color: "",
    secondary_color: "",
    text_color: "",
    background_color: "",
    document_id: "",
    country_code_phone1: "",
    country_code_phone2: "",
  });
  const [dirtyFields, setDirtyFields] = useState<any>({
    organisation_name: "",
    organisation_logo: "",
    industry: "",
    business_type: "",
    address1: "",
    address2: "",
    country_id: "",
    state_id: "",
    city_id: "",
    pincode: "",
    self_compliance_completion_backdate_limit_days: "",
    sc_future_date_completion_days_limit: "",
    auto_populate_self_compliance_completion_date: true,
    is_required_reason_for_non_compliance: false,
    phone1: "",
    phone2: "",
    email1: "",
    email2: "",
    primary_color: "",
    secondary_color: "",
    text_color: "",
    background_color: "",
    document_id: "",
    country_code_phone1: "",
    country_code_phone2: "",
  });

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [citiesList, setCityList] = useState([]);

  const [industryTypeList, setIndustryTypeList] = useState([]);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isLoading, setIsLoading] = useState(false);
  const [mobile_code1, setMobile_code1] = useState<any>("");
  const [mobile_code2, setMobile_code2] = useState<any>("");

  const [showPicker, setShowPicker] = useState(false);
  const [showPicker1, setShowPicker1] = useState(false);
  const [showPicker2, setShowPicker2] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getIndustryList();
      getBusinessTypeList();
      // getRegionList();
      getCountriesList();
      let user = JSON.parse(getValue(localStorage, `user`, ""));
      if (getValue(user, `org_id`, "") && props.permissionAPITriggered) {
        getData(getValue(user, `org_id`, ""));
      } else {
        setLoading(false);
      }
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getStatesList(request.country_id);
      if (request.state_id) {
        getCitiesList(request.state_id);
      }
    }
  }, [request.country_id, request.state_id, props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async (id: string) => {
    try {
      setLoading(true);
      let resp = await GetSpecificOrganization(id);
      if (resp) {
        let countryCode1 = countries.filter(
          (item: object) =>
            getValue(item, `dial_code`, "") ===
            getValue(resp, `data.data.country_code_phone1`, ""),
        );
        let countryCode2 = countries.filter(
          (item: object) =>
            getValue(item, `dial_code`, "") ===
            getValue(resp, `data.data.country_code_phone2`, ""),
        );
        // mobile_area_code
        let code1: any =
          countryCode1.length > 0 &&
          countryCode1.map((item) => ({
            id: getValue(item, `id`, ""),
            country: item.code,
            label: <>{item.dial_code + " " + item.name}</>,
            value: item.dial_code + " " + item.name,
          }));

        let code2: any =
          countryCode2.length > 0 &&
          countryCode2.map((item) => ({
            id: getValue(item, `id`, ""),
            country: item.code,
            label: <>{item.dial_code + " " + item.name}</>,
            value: item.dial_code + " " + item.name,
          }));
        const compDate =
          resp.data.data.self_compliance_completion_backdate_limit_days;
        const futureDateLimit =
          resp.data.data.sc_future_date_completion_days_limit;
        setRequest({
          ...request,
          country_id: getValue(resp, `data.data.country.id`, ""),
          state_id: getValue(resp, `data.data.state.id`, ""),
          city_id: getValue(resp, `data.data.city.id`, ""),
          address1: getValue(resp, `data.data.address1`, ""),
          address2: getValue(resp, `data.data.address2`, ""),
          organisation_name: getValue(resp, `data.data.organisation_name`, ""),
          organisation_logo: getValue(resp, `data.data.organisation_logo`, ""),
          vendor_code: getValue(resp, `data.data.vendor_code`, ""),
          pincode: getValue(resp, `data.data.pincode`, ""),
          self_compliance_completion_backdate_limit_days:
            compDate === "{}" ? null : compDate,
          sc_future_date_completion_days_limit:
            futureDateLimit === "{}" ? null : futureDateLimit,
          auto_populate_self_compliance_completion_date: getValue(
            resp,
            `data.data.auto_populate_self_compliance_completion_date`,
            true,
          ),

               is_required_reason_for_non_compliance: getValue(
            resp,
            `data.data.is_required_reason_for_non_compliance`,
            true,
          ),
          primary_color: getValue(resp, `data.data.primary_color`, ""),
          secondary_color: getValue(resp, `data.data.secondary_color`, ""),
          text_color: getValue(resp, `data.data.text_color`, ""),
          industry: getValue(resp, `data.data.industry.id`, ""),
          business_type: getValue(resp, `data.data.business_type.id`, ""),
          // region: getValue(resp, `data.data.region.id`, ""),
          phone1: getValue(resp, `data.data.phone1`, ""),
          phone2: getValue(resp, `data.data.phone2`, ""),
          email1: getValue(resp, `data.data.email1`, ""),
          email2: getValue(resp, `data.data.email2`, ""),
          background_color: getValue(resp, `data.data.background_color`, ""),

          country_code_phone1: getValue(
            resp,
            `data.data.country_code_phone1`,
            "",
          ),
          country_code_phone2: getValue(
            resp,
            `data.data.country_code_phone2`,
            "",
          ),
        });

        setDirtyFields({
          ...dirtyFields,
          country_id: getValue(resp, `data.data.country.id`, ""),
          state_id: getValue(resp, `data.data.state.id`, ""),
          city_id: getValue(resp, `data.data.city.id`, ""),
          address1: getValue(resp, `data.data.address1`, ""),
          address2: getValue(resp, `data.data.address2`, ""),
          organisation_name: getValue(resp, `data.data.organisation_name`, ""),
          organisation_logo: getValue(resp, `data.data.organisation_logo`, ""),
          vendor_code: getValue(resp, `data.data.vendor_code`, ""),
          pincode: getValue(resp, `data.data.pincode`, ""),
          self_compliance_completion_backdate_limit_days: getValue(
            resp,
            `data.data.self_compliance_completion_backdate_limit_days`,
            "",
          ),
          sc_future_date_completion_days_limit: getValue(
            resp,
            `data.data.sc_future_date_completion_days_limit`,
            "",
          ),
          auto_populate_self_compliance_completion_date: getValue(
            resp,
            `data.data.auto_populate_self_compliance_completion_date`,
            true,
          ),
          is_required_reason_for_non_compliance: getValue(
            resp,
            `data.data.is_required_reason_for_non_compliance`,
            true,
          ),
          primary_color: getValue(resp, `data.data.primary_color`, ""),
          secondary_color: getValue(resp, `data.data.secondary_color`, ""),
          text_color: getValue(resp, `data.data.text_color`, ""),
          industry: getValue(resp, `data.data.industry.id`, ""),
          business_type: getValue(resp, `data.data.business_type.id`, ""),
          // region: getValue(resp, `data.data.region.id`, ""),
          phone1: getValue(resp, `data.data.phone1`, ""),
          phone2: getValue(resp, `data.data.phone2`, ""),
          email1: getValue(resp, `data.data.email1`, ""),
          email2: getValue(resp, `data.data.email2`, ""),
          background_color: getValue(resp, `data.data.background_color`, ""),
          country_code_phone1: getValue(
            resp,
            `data.data.country_code_phone1`,
            "",
          ),
          country_code_phone2: getValue(
            resp,
            `data.data.country_code_phone2`,
            "",
          ),
        });
        setMobile_code1(
          getValue(code1, `length`, 0) > 0 ? getValue(code1, `[${0}]`, "") : "",
        );
        setMobile_code2(
          getValue(code2, `length`, 0) > 0 ? getValue(code2, `[${0}]`, "") : "",
        );

        // if (getValue(resp, `data.data.country.id`, '')) {
        //   getStatesList(getValue(resp, `data.data.country.id`, ''));
        // }
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getCountriesList = async () => {
    try {
      let resp = await GetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          })),
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    if (countryId)
      try {
        let resp = await GetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            })),
          );
        } else {
        }
      } catch (error) {}
  };

  const getIndustryList = async () => {
    try {
      let resp = await adminGetListManagementGroup("industry");
      if (resp) {
        setIndustryTypeList(
          getValue(resp, `data.listItems`, []).map((item: object) => ({
            id: getValue(item, `id`, ""),
            is_active: getValue(item, `is_active`, ""),
            text: getValue(item, `text`, ""),
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })),
        );
      } else {
      }
    } catch (error) {}
  };

  const getCitiesList = async (stateId: number) => {
    try {
      let resp = await GetCitiesListManagement(stateId);
      if (resp) {
        // console.log(resp);
        setCityList(
          getValue(resp, `data.cities`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          })),
        );
      } else {
      }
    } catch (error) {}
  };

  const getBusinessTypeList = async () => {
    try {
      let resp = await adminGetListManagementGroup("business-type");
      if (resp) {
        setBusinessTypeList(
          getValue(resp, `data.listItems`, []).map((item: object) => ({
            id: getValue(item, `id`, ""),
            is_active: getValue(item, `is_active`, ""),
            text: getValue(item, `text`, ""),
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })),
        );
      } else {
      }
    } catch (error) {}
  };
  const handleSubmit = async () => {
    let user = JSON.parse(getValue(localStorage, `user`, ""));
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      let payload = JSON.parse(JSON.stringify(request));

      payload.pincode = parseInt(payload.pincode);
      payload.country_id = parseInt(payload.country_id);
      payload.state_id = parseInt(payload.state_id);
      payload.city_id = parseInt(payload.city_id);
      payload.country_code_phone1 = getValue(mobile_code1, `value`, "").split(
        " ",
      )[0];
      payload.country_code_phone2 = getValue(mobile_code2, `value`, "").split(
        " ",
      )[0];
      Object.keys(payload).forEach((key) => {
        if (
          (payload[key] === "" || payload[key] === undefined || payload[key] === null)
        ) {
          delete payload[key];
        }
      });

      payload.is_required_reason_for_non_compliance =
        request.is_required_reason_for_non_compliance;

      const futureDateCompletionLimit =
        request.sc_future_date_completion_days_limit;
      payload.sc_future_date_completion_days_limit =
        futureDateCompletionLimit !== "" &&
        futureDateCompletionLimit !== undefined &&
        futureDateCompletionLimit !== null
          ? parseInt(futureDateCompletionLimit)
          : null;
      payload.self_compliance_completion_backdate_limit_days =
        payload.self_compliance_completion_backdate_limit_days
          ? parseInt(payload.self_compliance_completion_backdate_limit_days)
          : null;
      // if (getValue(params, `id`, "")) {
      try {
        setIsLoading(true);
        let resp = await UpdateSpecificOrganization(
          getValue(user, `org_id`, ""),
          payload,
        );
        if (resp) {
          setIsLoading(false);
          confirmNavigation();
          toast.success(getValue(resp, "message", ""));
          // navigate(`/configuration/vendors`);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
      // } else {
      // 	try {
      // 		setIsLoading(true);
      // 		let resp = await CreateOrganization(payload);
      // 		if (resp) {
      // 			setIsLoading(false);
      // 			toast.success(getValue(resp, "message", ""));
      // 			navigate(`/configuration/vendors`);
      // 		} else {
      // 			setIsLoading(false);
      // 		}
      // 	} catch (error) {
      // 		setIsLoading(false);
      // 	}
      // }
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setRequest({
        ...request,
        country_id: e.id,
      });
    }
    if (type === "state_id") {
      getCitiesList(e.id);
      setRequest({
        ...request,
        state_id: e.id,
      });
    }
    if (type === "industry") {
      setRequest({
        ...request,
        industry: e.id,
      });
    }
    if (type === "business_type") {
      setRequest({
        ...request,
        business_type: e.id,
      });
    }
    if (type === "city_id") {
      setRequest({
        ...request,
        city_id: e.id,
      });
    }
    if (type === "region") {
      setRequest({
        ...request,
        region: e.id,
      });
    }
    if (type === "vendor_type") {
      setRequest({
        ...request,
        vendor_type: e.value,
      });
    }
  };

  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: sanitizeInput(value),
    });
  };

  //   const handleChangeDate = (e: any) => {
  //     setRequest({
  //       ...request,
  //       commencement_date: e,
  //     });
  //   };

  //   const handleChangeCountryCode = (e: any) => {};

  const handleChangeFile = async (e: any) => {
    let user = JSON.parse(getValue(localStorage, `user`, ""));
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    try {
      let resp = await clientAdminPublicFileUpload(formData);
      if (resp) {
        let id = getValue(resp, `data.url`, "");
        let payload: any = {
          organisation_logo: id,
        };
        Object.keys(payload).forEach((key) => {
          if (!payload[key] || payload[key] === undefined) {
            delete payload[key];
          }
        });
        let response = await UpdateSpecificOrganization(
          getValue(user, `org_id`, ""),
          payload,
        );
        if (response) {
          localStorage.setItem("organisation_logo", id);
          getData(getValue(user, `org_id`, ""));
        }
      }
    } catch (error) {}
  };

  const handleChangeTextColor = (e: any, value: string) => {
    if (e.hex) {
      setRequest({
        ...request,
        [value]: e.hex,
      });
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                                Prompt Section                              */
  /* -------------------------------------------------------------------------- */
  const [isChanged, setIsChanged] = useState(false);
  useEffect(() => {
    setIsChanged(
      _.isEqualWith(request, dirtyFields, (a: any, b: any) => {
        // if both are null or equal to an empty string then they are equal
        if ((_.isNull(a) || a === "") && (_.isNull(b) || b === "")) return true;
      }),
    );
  });
  const [showPrompt, confirmNavigation, cancelNavigation]: any =
    useCallbackPrompt(!isChanged);

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!loading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "admin_general_org_profile",
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <PromptModal
            showDialog={showPrompt}
            confirmNavigation={confirmNavigation}
            cancelNavigation={cancelNavigation}
          />
          <div className="dashboard-wrapper__header">
            <h4 className="dashbaord-wrapper__header-title">
              Organization Profile
            </h4>
          </div>
          {loading || !props.permissionAPITriggered ? (
            <Loader />
          ) : (
            <>
              <div className="user-details-wrapper m-0">
                <div className="org-profile-wrapper d-flex align-items-flex-start justify-content-between">
                  <label className="org-profile-wrapper-image cursor-pointer">
                    <img
                      src={
                        getValue(request, `organisation_logo`, "")
                          ? getValue(
                              request,
                              `organisation_logo`,
                              "imagespharmeasy-image.png",
                            )
                          : "https://juliaja.nl/wp-content/uploads/2021/04/noimagefound24-1024x576.png"
                      }
                      // className="img=fluid"
                      width={364}
                      height={119}
                    />
                    <input
                      type={"file"}
                      onChange={handleChangeFile}
                      className="d-none"
                    />
                  </label>
                  <div className="org-profile-wrapper__details">
                    <h4 className="org-profile-wrapper__details-heading">
                      Organization Logo
                    </h4>
                    <p className="org-profile-wrapper__details-text">
                      This logo will appear on the tool bar for all users.{" "}
                      <span>
                        Preferred Image Size: 240px x 240px @ 72 DPI Maximum
                        size of 1MB.
                      </span>
                    </p>
                  </div>
                </div>
                <div className="checkpoint-active-details-wrapper__form-wrapper">
                  <div className="checkpoint-active-details-wrapper__form-content">
                    <div className="user-details-wrapper__form-group form-group">
                      <label className="checkpoint-active-details__label">
                        Organization Name <span>*</span>
                      </label>
                      <InputField
                        inputType="TEXT"
                        placeholder="Enter Location Name"
                        className="form-control w-100"
                        name="organisation_name"
                        id="organisation_name"
                        value={getValue(request, `organisation_name`, "")}
                        onChange={(e: any) => handleChangeText(e)}
                        label="Organisation Name"
                        validator={simpleValidator}
                      />
                    </div>
                    <div className="user-details-wrapper__form user-details-wrapper__form--org-profile">
                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Industry <span>*</span>
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Enter Industry"
                          className="form-control w-100"
                          name="industry"
                          id="industry"
                          options={industryTypeList}
                          value={industryTypeList.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(request, `industry`, ""),
                          )}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "industry")
                          }
                          label="Industry"
                          validator={simpleValidator}
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group mb-3">
                        <label className="checkpoint-active-details__label">
                          Business Type <span>*</span>
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Enter Business Type"
                          className="form-control w-100"
                          name="business_type"
                          id="business_type"
                          options={businessTypeList}
                          value={businessTypeList.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(request, `business_type`, ""),
                          )}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "business_type")
                          }
                          label="Business Type"
                          validator={simpleValidator}
                        />
                      </div>
                    </div>
                    <div className="user-details-wrapper__form-group form-group mb-3">
                      <label className="checkpoint-active-details__label">
                        Company Address (Line 1)<span>*</span>
                      </label>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Company Address (Line 1)"
                        className="form-control w-100"
                        name="address1"
                        id="address1"
                        label="Address Line1"
                        value={getValue(request, `address1`, "")}
                        onChange={(e: any) => handleChangeText(e)}
                        validator={simpleValidator}
                      />
                    </div>

                    <div className="user-details-wrapper__form-group form-group mb-3">
                      <label className="checkpoint-active-details__label">
                        Company Address (Line 2)<span></span>
                      </label>
                      <InputField
                        inputType="TEXTAREA"
                        placeholder="Enter Company Address (Line 2)"
                        className="form-control w-100"
                        name="address2"
                        id="address2"
                        label="Address Line2"
                        value={getValue(request, `address2`, "")}
                        onChange={(e: any) => handleChangeText(e)}
                        // validator={simpleValidator}
                      />
                    </div>
                    <div className="user-details-wrapper__form  user-details-wrapper__form--org-profile">
                      <div className="user-details-wrapper__form-group form-group mb-3">
                        <label className="checkpoint-active-details__label">
                          Country <span>*</span>
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Choose Country"
                          className="form-control w-100"
                          name="country_id"
                          id="country_id"
                          options={countryList}
                          value={countryList.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(request, `country_id`, ""),
                          )}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "country_id")
                          }
                          label="Country"
                          validator={simpleValidator}
                        />
                      </div>
                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          State <span>*</span>
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Choose State"
                          className="form-control w-100"
                          name="state_id"
                          id="state_id"
                          label="Last Name"
                          options={states}
                          value={states.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(request, `state_id`, ""),
                          )}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "state_id")
                          }
                          validator={simpleValidator}
                        />
                      </div>
                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          City <span>*</span>
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT"
                          placeholder="Choose State"
                          className="form-control w-100"
                          name="city_id"
                          id="city_id"
                          label="City"
                          options={citiesList}
                          value={citiesList.filter(
                            (item: object) =>
                              getValue(item, `id`, "") ==
                              getValue(request, `city_id`, ""),
                          )}
                          onChange={(e: any) =>
                            handleChangeSelect(e, "city_id")
                          }
                          validator={simpleValidator}
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Pincode <span>*</span>
                        </label>
                        <InputField
                          inputType="TEXT"
                          placeholder="Enter Pincode"
                          className="form-control w-100"
                          name="pincode"
                          id="pincode"
                          value={getValue(request, `pincode`, "")}
                          onChange={(e: any) => handleChangeText(e)}
                          label="Pincode"
                          validator={simpleValidator}
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Area Code 1<span>*</span>
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT_COUNTYCODE"
                          placeholder="Enter Area Code 1"
                          className="form-control w-100"
                          name="mobile_area_code"
                          id="mobile_area_code"
                          label="Mobile Area Code"
                          value={mobile_code1}
                          onChange={(e: any) => setMobile_code1(e)}
                          validator={simpleValidator}
                        />
                      </div>
                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Phone Number 1<span>*</span>
                        </label>
                        <InputField
                          inputType="PHONE"
                          placeholder="Enter Phone Number 1"
                          className="form-control w-100"
                          name="phone1"
                          id="phone1"
                          label="Mobile Number"
                          value={getValue(request, `phone1`, "")}
                          onChange={(e: any) => handleChangeText(e)}
                          validator={simpleValidator}
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Area Code 2
                        </label>
                        <InputField
                          inputType="INPUT_REACT_SELECT_COUNTYCODE"
                          placeholder="Enter Area Code 2"
                          className="form-control w-100"
                          name="mobile_area_code"
                          id="mobile_area_code"
                          label="Mobile Area Code"
                          value={mobile_code2}
                          onChange={(e: any) => setMobile_code2(e)}
                          // validator={simpleValidator}
                        />
                      </div>
                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Phone Number 2
                        </label>
                        <InputField
                          inputType="PHONE"
                          placeholder="Enter Phone Number 2"
                          className="form-control w-100"
                          name="phone2"
                          id="phone2"
                          label="Mobile Number"
                          value={getValue(request, `phone2`, "")}
                          onChange={(e: any) => handleChangeText(e)}
                          // validator={simpleValidator}
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Email Address 1<span>*</span>
                        </label>
                        <InputField
                          inputType="EMAIL"
                          placeholder="Enter Email Address 1"
                          className="form-control w-100"
                          name="email1"
                          id="email1"
                          value={getValue(request, `email1`, "")}
                          onChange={(e: any) => handleChangeText(e)}
                          label="Email"
                          validator={simpleValidator}
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Email Address 2<span></span>
                        </label>
                        <InputField
                          inputType="EMAIL"
                          placeholder="Enter Email Address 2"
                          className="form-control w-100"
                          name="email2"
                          id="email2"
                          value={getValue(request, `email2`, "")}
                          onChange={(e: any) => handleChangeText(e)}
                          label="email2"
                        />
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Self Compliance Completion Backdate Limit Days
                        </label>
                        <InputField
                          inputType="TEXT"
                          placeholder="Enter days or leave it empty"
                          className="form-control w-100"
                          name="self_compliance_completion_backdate_limit_days"
                          id="self_compliance_completion_backdate_limit_days"
                          value={getValue(
                            request,
                            `self_compliance_completion_backdate_limit_days`,
                            null,
                          )}
                          onChange={(e: any) => handleChangeText(e)}
                          label="self Compliance Completion Backdate Limit Days"
                        />
                      </div>

                        <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Self Compliance Completion Future Date Limit
                        </label>
                        <InputField
                          inputType="TEXT"
                          placeholder="Enter days or leave it empty"
                          className="form-control w-100"
                          name="sc_future_date_completion_days_limit"
                          id="sc_future_date_completion_days_limit"
                          value={getValue(
                            request,
                            `sc_future_date_completion_days_limit`,
                            null,
                          )}
                          onChange={(e: any) => handleChangeText(e)}
                          label="self Compliance Completion Future Date Limit"
                        />
                      </div>


                      <div className="user-details-wrapper__form-group form-group d-flex align-items-center mt-3" style={{ gap: "8px" }}>
                        <label className="m-0 position-relative" htmlFor="auto_populate_self_compliance_completion_date">
                          <input
                            type="checkbox"
                            className="default-checkbox"
                            name="auto_populate_self_compliance_completion_date"
                            id="auto_populate_self_compliance_completion_date"
                            checked={getValue(request, `auto_populate_self_compliance_completion_date`, false)}
                            onChange={(e: any) => {
                              setRequest({
                                ...request,
                                auto_populate_self_compliance_completion_date: e.target.checked,
                              });
                            }}
                          />
                          <div className="custom-checkbox">
                            <img
                              src="/images/uploaded-details/tick.svg"
                              className="img-fluid uploaded-tick"
                            />
                          </div>
                        </label>
                        <label className="checkpoint-active-details__label mb-0 cursor-pointer" htmlFor="auto_populate_self_compliance_completion_date" style={{ userSelect: "none" }}>
                          Auto Populate Self Compliance Completion Date
                        </label>
                      </div>

                      <div className="user-details-wrapper__form-group form-group d-flex align-items-center mt-3" style={{ gap: "8px" }}>
                        <label className="m-0 position-relative" htmlFor="is_required_reason_for_non_compliance">
                          <input
                            type="checkbox"
                            className="default-checkbox"
                            name="is_required_reason_for_non_compliance"
                            id="is_required_reason_for_non_compliance"
                            checked={
                              request.is_required_reason_for_non_compliance === true
                            }
                            onChange={(e: any) => {
                              setRequest({
                                ...request,
                                is_required_reason_for_non_compliance: e.target.checked,
                              });
                            }}
                          />
                          <div className="custom-checkbox">
                            <img
                              src="/images/uploaded-details/tick.svg"
                              className="img-fluid uploaded-tick"
                            />
                          </div>
                        </label>
                        <label className="checkpoint-active-details__label mb-0 cursor-pointer" htmlFor="is_required_reason_for_non_compliance" style={{ userSelect: "none" }}>
                          Is Required Reason For Non Compliance
                        </label>
                      </div>

                      {/* <div className="user-details-wrapper__form-group form-group">
								<label className="checkpoint-active-details__label">
									Region <span>*</span>
								</label>
								<InputField
									inputType="INPUT_REACT_SELECT"
									placeholder="Choose Region"
									className="form-control w-100"
									name="region"
									id="region"
									options={regionTypeList}
									value={regionTypeList.filter(
										(item: object) =>
											getValue(item, `id`, "") ==
											getValue(request, `region`, "")
									)}
									onChange={(e: any) => handleChangeSelect(e, "region")}
									label="Region"
									validator={simpleValidator}
								/>
							</div> */}
                    </div>

                    <h4 className="mb-3">Color Theme</h4>

                    <div className="user-details-wrapper__form  user-details-wrapper__form--org-profile">
                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Brand Primary Color <span>*</span>
                        </label>
                        <div className="position-relative">
                          <InputField
                            inputType="TEXT"
                            placeholder="Enter Primary Color"
                            className="form-control w-100"
                            name="primary_color"
                            id="primary_color"
                            value={getValue(request, `primary_color`, "")}
                            // onChange={(e: any) => handleChangeText(e)}
                            label="Primary Color"
                            validator={simpleValidator}
                            disabled
                          />
                          <div className="form-group cursor-pointer color-picker-edit color-picker-edit--org-profile">
                            <div className="color-picker">
                              {showPicker ? (
                                <img
                                  src={`/images/close-red.svg`}
                                  onClick={() => {
                                    setShowPicker(!showPicker);
                                    setShowPicker1(false);
                                    setShowPicker2(false);
                                  }}
                                />
                              ) : (
                                <img
                                  src={`/images/color.svg`}
                                  onClick={() => {
                                    setShowPicker(!showPicker);
                                    setShowPicker1(false);
                                    setShowPicker2(false);
                                  }}
                                />
                              )}

                              {showPicker && (
                                <>
                                  <div className="color-picker-component">
                                    <ChromePicker
                                      onChange={(d: any) =>
                                        handleChangeTextColor(
                                          d,
                                          "primary_color",
                                        )
                                      }
                                      color={
                                        getValue(request, `primary_color`, "")
                                          ? getValue(
                                              request,
                                              `primary_color`,
                                              "",
                                            )
                                          : "#000000"
                                      }
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="user-details-wrapper__form  user-details-wrapper__form--org-profile">
                        <div className="user-details-wrapper__form-group form-group">
                          <label className="checkpoint-active-details__label">
                            Brand Secondary Color <span>*</span>
                          </label>
                          <div className="position-relative">
                            <InputField
                              inputType="TEXT"
                              placeholder="Enter Secondary Color"
                              className="form-control w-100"
                              name="secondary_color"
                              id="secondary_color"
                              value={getValue(request, `secondary_color`, "")}
                              // onChange={(e: any) => handleChangeText(e)}
                              label="Secondary Color"
                              validator={simpleValidator}
                              disabled
                            />
                            <div className="cursor-pointer form-group color-picker-edit color-picker-edit--org-profile">
                              <div className="color-picker">
                                {showPicker1 ? (
                                  <img
                                    src={`/images/close-red.svg`}
                                    onClick={() => {
                                      setShowPicker1(!showPicker1);
                                      setShowPicker(false);
                                      setShowPicker2(false);
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={`/images/color.svg`}
                                    onClick={() => {
                                      setShowPicker1(!showPicker1);
                                      setShowPicker(false);
                                      setShowPicker2(false);
                                    }}
                                  />
                                )}

                                {showPicker1 && (
                                  <>
                                    <div className="color-picker-component">
                                      <ChromePicker
                                        onChange={(d: any) =>
                                          handleChangeTextColor(
                                            d,
                                            "secondary_color",
                                          )
                                        }
                                        color={
                                          getValue(
                                            request,
                                            `secondary_color`,
                                            "",
                                          )
                                            ? getValue(
                                                request,
                                                `secondary_color`,
                                                "",
                                              )
                                            : "#000000"
                                        }
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="user-details-wrapper__form-group form-group">
                        <label className="checkpoint-active-details__label">
                          Button Text Color <span>*</span>
                        </label>
                        <div className="position-relative">
                          <InputField
                            inputType="TEXT"
                            placeholder="Enter Text Color"
                            className="form-control w-100 mr-2"
                            name="text_color"
                            id="text_color"
                            value={getValue(request, `text_color`, "")}
                            onChange={(e: any) => handleChangeText(e)}
                            label="Text Color"
                            validator={simpleValidator}
                            disabled
                          />
                          <div className="cursor-pointer form-group color-picker-edit color-picker-edit--org-profile">
                            <div className="color-picker">
                              {showPicker2 ? (
                                <img
                                  src={`/images/close-red.svg`}
                                  onClick={() => {
                                    setShowPicker2(!showPicker2);
                                    setShowPicker(false);
                                    setShowPicker1(false);
                                  }}
                                />
                              ) : (
                                <img
                                  src={`/images/color.svg`}
                                  onClick={() => {
                                    setShowPicker2(!showPicker2);
                                    setShowPicker(false);
                                    setShowPicker1(false);
                                  }}
                                />
                              )}

                              {showPicker2 && (
                                <>
                                  <div className="color-picker-component">
                                    <ChromePicker
                                      onChange={(d: any) =>
                                        handleChangeTextColor(d, "text_color")
                                      }
                                      color={
                                        getValue(request, `text_color`, "")
                                          ? getValue(request, `text_color`, "")
                                          : "#000000"
                                      }
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {getValue(props, `permissions`, []).includes("update") && (
                      <div className="user-details-wrapper__cta-btns">
                        {/* <NavLink to={`/checkpoint/active`}>
									<button className="ascent-button ascent-button--header-buttons ascent-button--primary">
										Cancel
									</button>
									</NavLink> */}
                        {isLoading ? (
                          <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                            Please wait...
                          </button>
                        ) : (
                          <button
                            className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                            onClick={handleSubmit}
                          >
                            {getValue(params, `id`, "") ? "Update" : "Submit"}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="text-center">
                <img src="/images/footer-image.svg" className="img-fluid" />
              </div>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default OrgProfile;
